import React from 'react';

const Privacy_Policy = () => {
  return (
    <div className='policies_container'>
      <div className='policies_cont'>
        <p className='title_policy'>Privacy Policy</p>
        <p><strong>Last updated: May 07, 2026</strong></p>

        <p className='declaration_policy'>
          Project E8 ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and handle your information when you use our platform and our Model Context Protocol (MCP) services.
        </p>

        {/* MANDATORY SECTION FOR GOOGLE VERIFICATION */}
        <p className='section_titles' style={{ color: '#d93025' }}>1. Google API Disclosure & Limited Use</p>
        <p className='description_policy'>
          Project E8 uses Google APIs to allow our AI assistant to interact with your Gmail account. Our use and transfer of information received from Google APIs to any other app will adhere to the <strong><a href="https://developers.google.com/terms/api-services-user-data-policy#limited-use-requirements" target="_blank" rel="noreferrer">Google API Services User Data Policy</a></strong>, including the Limited Use requirements.
        </p>
        <ul className='description_policy'>
            <li>We only use Gmail access to provide or improve user-facing features that are prominent in our interface (e.g., allowing your AI assistant to search or summarize your emails).</li>
            <li>We do <strong>not</strong> use Google user data for serving advertisements, including retargeting, personalized, or interest-based advertising.</li>
            <li>We do <strong>not</strong> allow humans to read your Gmail data unless we have obtained your affirmative agreement for specific messages (e.g., for support), it is necessary for security purposes, or to comply with applicable law.</li>
        </ul>

        <p className='section_titles'>2. Interpretation and Definitions</p>
        <p className='description_policy'>
          <strong>Company:</strong> Refers to Project E8 - Zyber Pireci, Milano, Via Emilio Gola 5 - 20143 (MI).<br/>
          <strong>Service:</strong> Refers to the Project E8 platform and any AI/MCP integrations provided.<br/>
          <strong>Personal Data:</strong> Any information that relates to an identified or identifiable individual, specifically including data accessed via Google OAuth.
        </p>

        <p className='section_titles'>3. Collecting and Using Your Personal Data</p>
        <p className='description_policy'><strong>Types of Data Collected:</strong></p>
        <ul className='description_policy'>
          <li><strong>Identity Data:</strong> Email address and name provided during Google Sign-In.</li>
          <li><strong>Gmail Data:</strong> When you authorize our MCP server, we access email headers, message bodies, and attachments solely to pass them to the AI model as context for your queries.</li>
          <li><strong>Usage Data:</strong> Information on how you interact with our AI tools.</li>
        </ul>

        <p className='section_titles'>4. AI Data Handling and Privacy</p>
        <p className='description_policy'>
            Our platform acts as a bridge (MCP) between your Google account and AI models.
        </p>
        <ul className='description_policy'>
          <li><strong>No Model Training:</strong> We do not use your Personal Data or Gmail content to train, improve, or fine-tune foundational AI models.</li>
          <li><strong>Data Minimization:</strong> We only request the minimum permissions necessary for the AI to perform the tasks you request.</li>
        </ul>

        <p className='section_titles'>5. Use of Your Personal Data</p>
        <p className='description_policy'>
          The Company uses your data to:
        </p>
        <ul className='description_policy'>
          <li>Provide the AI functionality you requested (e.g., "Summarize my last 5 emails").</li>
          <li>Manage your Account and provide technical support.</li>
          <li>Ensure the security of our Service.</li>
        </ul>

        <p className='section_titles'>6. Retention and Deletion</p>
        <p className='description_policy'>
          We retain Gmail data only for as long as necessary to fulfill your specific AI request, or as defined by your account settings. You may revoke access at any time via your Google Security settings or by deleting your Project E8 account.
        </p>

        <p className='section_titles'>7. Disclosure of Your Personal Data</p>
        <p className='description_policy'>
          We do not sell your personal data. We only share data with Service Providers (such as AI model providers like OpenAI or Anthropic) to the extent necessary to process your specific AI prompts. These providers are contractually obligated to keep your data private and secure.
        </p>

        <p className='section_titles'>8. Contact Us</p>
        <p className='description_policy'>
          If you have any questions about this Privacy Policy or our Google Data handling, contact us at: <strong>support@projecte8.com</strong>
        </p>

        {/* ✅ NEW REQUIRED SECTION */}
        <p className='section_titles'>9. Data Security and Protection Measures</p>
        <p className='description_policy'>
          We implement appropriate technical and organizational measures to protect your Personal Data, including data accessed via Google APIs, against unauthorized access, alteration, disclosure, or destruction.
        </p>
        <ul className='description_policy'>
          <li><strong>Encryption in transit and at rest:</strong> All data transmitted between our systems and third-party services (including Google APIs) is encrypted using industry-standard protocols (e.g., HTTPS/TLS). Where applicable, stored data is encrypted at rest.</li>
          <li><strong>Access controls:</strong> Access to Personal Data is restricted to authorized systems and personnel who require it to operate the Service.</li>
          <li><strong>Data minimization:</strong> We only process the minimum amount of data necessary to fulfill your request.</li>
          <li><strong>Secure processing:</strong> Gmail data is processed in real time and is not stored beyond what is necessary to complete your request, unless explicitly stated.</li>
          <li><strong>Monitoring and logging:</strong> We maintain logs and monitoring systems to detect and prevent unauthorized access or misuse.</li>
          <li><strong>Third-party safeguards:</strong> Service providers (such as AI providers) are contractually obligated to implement appropriate security measures and process data only on our instructions.</li>
        </ul>
        <p className='description_policy'>
          Despite our efforts, no method of transmission over the Internet or electronic storage is completely secure. However, we continuously work to protect your data using commercially acceptable means.
        </p>

      </div>
    </div>
  );
};

export default Privacy_Policy;